// extracted by mini-css-extract-plugin
module.exports = {"imageGallery":"styles_imageGallery__1WFf_","image":"styles_image__N8Olg","mainImage":"styles_mainImage__1ADyX"};